import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderInterceptor, HttpErrorInterceptor } from './_interceptors/index';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';

import { HeaderComponent } from './starter/header/header.component';
import { FooterComponent } from './starter/footer/footer.component';
import { autoLogoutModule } from './autoLogout/autoLogout.module';
import { CustomOwlCarouselComponent } from './pages/reusable/custom-owl-carousel/custom-owl-carousel.component';
import { CityUpdateComponent } from './pages/city-update/city-update.component';
import { CityCardComponent } from './pages/reusable/city-card/city-card.component';
import { NoDataComponent } from './pages/reusable/no-data/no-data.component';
// import { SkeletonCityCardComponent } from './pages/reusable/skeleton-city-card/skeleton-city-card.component';
// import { PropertyDetailsCardComponent } from './pages/reusable/property-details-card/property-details-card.component';
import { AlertRibbonComponent } from './pages/reusable/alert-ribbon/alert-ribbon.component';
import { CountdownComponent } from './pages/reusable/countdown/countdown.component';
import { NotificationComponent } from './pages/notification/notification/notification.component';
import { TabMenuComponent } from './pages/reusable/tab-menu/tab-menu.component';
// import { NotificationDetailsComponent } from './pages/notification/notification-details/notification-details.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    AlertRibbonComponent,
    CountdownComponent,
    NotificationComponent,
    // NotificationDetailsComponent,
    // MaintainenceComponent,
    // NoPageFoundComponent,
    // HomeComponent,
    // BuyingGuideComponent,
    // KeyFactorsSectionComponent,
    // LoanLenderSectionComponent,
    // CityUpdateComponent,
    // TabMenuComponent,
    // CityCardComponent,
    // NoDataComponent,
    // SkeletonCityCardComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxUiLoaderModule,
    FormsModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    autoLogoutModule
],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
